import debug from '../debugger';

const commonDelimiters = [' - ', ' | ', ': '];
const streamTitleRegex = /StreamTitle='([\s\S]*?)';/;
const adBreakIndicator = 'adw_ad=';
const icyAdBreakTitles = {
  TIADSTART: true,
  TIADMID: true,
  TIADEND: true,
};

export function parseIcyMetadata(metadata) {
  debug.log('Parsing Icy Metadata', metadata);

  const transformedMetadata = {
    title: '',
    subtitle: '',
    isAdBreak: metadata.includes(adBreakIndicator),
    delayMs: 10_000, // delays the metadata by 10 seconds
  };

  if (transformedMetadata.isAdBreak) {
    return transformedMetadata;
  }

  // Regular expression to find the StreamTitle
  const streamTitleMatch = streamTitleRegex.exec(metadata);

  if (!streamTitleMatch) {
    return transformedMetadata;
  }

  const streamTitle = streamTitleMatch[1];

  // eslint-disable-next-line no-restricted-syntax
  for (const delimiter of commonDelimiters) {
    if (!streamTitle.includes(delimiter)) {
      // eslint-disable-next-line no-continue
      continue;
    }

    const [title, subtitle] = streamTitle.split(delimiter) || [];

    transformedMetadata.title = title?.trim();
    transformedMetadata.subtitle = subtitle?.trim();
    break;
  }

  // If no delimiter is found, treat the entire string as the title
  if (!transformedMetadata.title && streamTitle?.trim().length) {
    transformedMetadata.title = streamTitle.trim();
  }

  if (icyAdBreakTitles[transformedMetadata.title]) {
    transformedMetadata.isAdBreak = true;
  }

  debug.log('Parsed Icy Metadata', transformedMetadata);

  return transformedMetadata;
}
